import {
  Project,
  ProjectDetailsField,
  ProjectDetailsFieldType,
  TeamRole,
  useAuthenticationContextRequired
} from "nekst-api";
import {
  AfterSubmitFunc,
  DateInput,
  FormTemplate,
  PriceInput,
  Text,
  TextArea,
  TextInput,
  useShowContextRequired
} from "ui-builder";
import { useUpdateListHelper } from "./updateListHelper";
import React from "react";
import { usePopupFormManager } from "features/nekst-widgets";
import styles from './UpdateFieldWrapper.module.scss';
import { OpenTaskWrapper } from "./OpenTaskWrapper";

export function UpdateFieldForm(props: {
  field: ProjectDetailsField,
  initialValue?: any,
  afterSubmitFunc?: AfterSubmitFunc,
}) {
  const { data: project } = useShowContextRequired<Project>();

  const updateListHelper = useUpdateListHelper();

  let InputWidget;


  switch (props.field.fieldType) {
    case ProjectDetailsFieldType.DATE:
      InputWidget = DateInput;
      break;
    case ProjectDetailsFieldType.PRICE:
      InputWidget = PriceInput;
      break;
    case ProjectDetailsFieldType.LONG_TEXT:
      InputWidget = TextArea;
      break;
    default:
      InputWidget = TextInput;
      break;
  }

  return (
    <FormTemplate
      title={`Edit "${props.field.name}" (${project.name})`}
      submitFormFunc={async (data) => {
        await updateListHelper.updateFieldsAndListView(props.field.id, data.value);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={{
        value: props.initialValue,
      }}
    >
      <InputWidget source="value" label="Value" hideLabel />
    </FormTemplate>
  )
}


export function UpdateFieldWrapper(
  props: {
    field: ProjectDetailsField,
    children: React.ReactNode,
  }
) {

  const context = useShowContextRequired<Project>();

  const project = context.data;

  const details = context.data.statistic!.details;

  const fieldValueObj = details
    .find((d) => d.setting.id === props.field.id);

  const date = fieldValueObj?.value;


  const popupFormManager = usePopupFormManager();

  const onClick = () => {
    popupFormManager.openForm((
      <UpdateFieldForm
        field={props.field}
        initialValue={date}
      />
    ));
  };

  const authenticationContext = useAuthenticationContextRequired();

  const isOwnerOrAdmin = [TeamRole.OWNER, TeamRole.ADMINISTRATOR].includes(authenticationContext.user.teamRole)

  if (isOwnerOrAdmin) {
    if (props.field._setupArea?.id === project._setupArea?.id) {

      if (fieldValueObj?.linkedTask) {
        return (
          <OpenTaskWrapper taskId={fieldValueObj.linkedTask.id} projectId={project.id}>
            {props.children}
          </OpenTaskWrapper>
        );
      } else {
        return (
          <Text onClick={onClick} className={styles.container}>
            {props.children}
          </Text>
        );
      }
    } else {
      return null;
    }
  } else {
    return props.children;
  }
}
